import {
  AccountInfo,
  AccountOperator,
  ERole,
  IInviteUserDialogOptions,
  IInvitedUsers,
  NewAccountOperator,
  OperatorBusinessType,
  OperatorIPAddress,
  OperatorOnboardingData,
  TOnboardingProgress,
  TCopystakeIntegration,
  TOperatorWebhooks,
  TCopystakeAggregation
} from '@/api/schema';

export const defaultOnboardingData: OperatorOnboardingData = {
  ggr: '',
  name: '',
  test: true,
  tokenName: '',
  tokenNumber: 0,
  tokenPrice: 0,
  tokenTicker: '',
  url: '',
  businessType: OperatorBusinessType.casino,
  deployed: false,
  ip: [],
  proxy: '',
  status: '',
  liquidityPoolAddress: ''
};

/**
 * The initial state for Onboarding.
 * @category  Onboarding.
 */

export default {
  onboardingData: { ...defaultOnboardingData },
  operators: [],
  newOperator: {},
  selectedOperator: {},
  operatorDialogData: {},
  loading: {
    formData: true,
    apiKeys: false,
    truePlayIPs: false,
    operatorIPs: false,
    mode: false,
    operators: true,
    operatorDialog: false,
    progress: false,
    copyStakeIntegration: false,
    operatorWebhooks: false,
    copyStakeAggregationConfig: false
  },
  proxyUrl: null,
  apiKey: null,
  secret: null,
  integrationUrl: null,
  acceptProxyUrl: null,
  displayOperatorDialog: false,
  truePlayIPs: [],
  operatorIPs: [],
  accountInfo: null,
  inviteUserDialog: {
    title: undefined,
    description: undefined,
    list: [],
    show: false,
    closable: false
  },
  onboardingProgress: {},
  trafficProdProgress: null,
  inviteLinks: [],
  inviteUsers: [],
  copyStakeIntegration: {},
  operatorWebhooks: {},
  copyStakeAggregationConfig: {}
};

/**
 * Describes Onboarding state.
 * @category Onboarding.
 */
export interface OnboardingState {
  onboardingData: OperatorOnboardingData;
  operators: AccountOperator[];
  newOperator: NewAccountOperator;
  selectedOperator: AccountOperator;
  operatorDialogData: AccountOperator;
  loading: {
    formData: boolean;
    apiKeys: boolean;
    truePlayIPs: boolean;
    operatorIPs: boolean;
    mode: boolean;
    operators: boolean;
    operatorDialog: boolean;
    progress: boolean;
    copyStakeIntegration: boolean;
  };
  apiKey: string | null;
  proxyUrl: string | null;
  acceptProxyUrl: string | null;
  secret: string | null;
  integrationUrl: string | null;
  displayOperatorDialog: boolean;
  truePlayIPs: string[];
  operatorIPs: OperatorIPAddress[];
  accountInfo: Partial<AccountInfo>;
  inviteUserDialog: IInviteUserDialogOptions;
  onboardingProgress: Record<string, TOnboardingProgress>;
  trafficProdProgress: TOnboardingProgress;
  inviteLinks: { role: ERole; link: string }[];
  inviteUsers: IInvitedUsers[];
  copyStakeIntegration: TCopystakeIntegration;
  operatorWebhooks: TOperatorWebhooks;
  copyStakeAggregationConfig: TCopystakeAggregation;
}
